import React from "react"
import type { StyleProps } from "@mallardbay/lib-react-components"

import QuoteSummary from "~components/shared/quote/quote-summary"
import type {
    QuoteListingFieldsFragment,
    QuoteInterfaceFieldsFragment,
} from "~graphql/generated/graphql"
import BookingSummaryContainer from "~components/pages/book/booking-summary-container"
import BookingSummaryCancellationPolicy from "~components/pages/book/booking-summary-cancellation-policy"
import Box from "~components/shared/todo-lib-react-components/box"
import { getFirstPhotoUrl } from "~utils/helpers"
import Spinner from "~components/shared/todo-lib-react-components/spinner"
import type { OnEditPackageClickFunc } from "~components/shared/quote/quote-package-buttons"

interface Props {
    readonly title?: string
    readonly note?: string | null
    readonly listing?: QuoteListingFieldsFragment | null
    readonly quote?: QuoteInterfaceFieldsFragment | null
    readonly isQuoteLoading?: boolean
    readonly shouldShowDeleteButtons?: boolean
    readonly onEditPackageClick?: OnEditPackageClickFunc
    readonly noPaddingOnMobile?: boolean
    readonly shouldShowProcessingFeeWarning?: boolean
}

export default function BookingSummary({
    title,
    note,
    listing,
    quote,
    isQuoteLoading,
    shouldShowDeleteButtons,
    onEditPackageClick,
    noPaddingOnMobile,
    shouldShowProcessingFeeWarning,
}: Props) {
    const styles = useStyles()

    return (
        <>
            <BookingSummaryContainer
                title={title}
                note={note}
                shouldHideListingHeader={!listing}
                imageUrl={getFirstPhotoUrl(listing?.photos)}
                listingTitle={listing?.title}
                locationState={listing?.location?.state}
                listingType={listing?.type}
                noPaddingOnMobile={noPaddingOnMobile}
            >
                {isQuoteLoading ? (
                    <Box style={styles.loadingDots}>
                        <Spinner noPadding />
                    </Box>
                ) : (
                    <QuoteSummary
                        quote={quote}
                        shouldShowDeleteButtons={shouldShowDeleteButtons}
                        onEditPackageClick={onEditPackageClick}
                        shouldShowProcessingFeeWarning={
                            shouldShowProcessingFeeWarning
                        }
                    />
                )}
            </BookingSummaryContainer>
            <BookingSummaryCancellationPolicy quote={quote} />
        </>
    )
}

function useStyles() {
    const loadingDots: StyleProps = {
        paddingTop: 6,
    }

    return { loadingDots }
}
